import { AccessPermissions } from './auth/Permissions/PermissionContext';
import { hasPermission } from './auth/Permissions/PermissionModule';
import { PermissionConcerns, PermissionTypes } from './auth/Permissions/PermissionStrings';

export interface INavigationElement {
    title: string;
    headerTitle: string;
    path: string;
    to: string;
    navigate: Function
}

export function navigateHome() {
    Root.navigate();
}

export const Root: INavigationElement = {
    title: "Dashboard",
    headerTitle: "Dashboard",
    path: '/',
    to: '/',
    navigate: (navigateFnc: Function) => { navigateFnc('/') }
};

export const CreateRecalls: INavigationElement = {
    title: "CreateRecall",
    headerTitle: "Recalls",
    path: 'CreateRecall/:recallId?',
    to: '/CreateRecall',
    navigate: (navigateFnc: Function, recallId?: string) => { navigateFnc(`/CreateRecall${recallId ? `/${recallId}` : ""}`) }
};

export const Establishments: INavigationElement = {
    title: "Establishments",
    headerTitle: "Establishments",
    path: 'Establishments/:entityName?',
    to: '/Establishments',
    navigate: (navigateFnc: Function, entityName?: string) => { navigateFnc(`/Establishments${entityName ? `/${entityName}` : ""}`) }
}

export const Customers: INavigationElement = {
    title: "Customers",
    headerTitle: "Customers",
    path: 'Customers/',
    to: '/Customers',
    navigate: (navigateFnc: Function) => { navigateFnc(`/Customers`) }
}

export const Accounts: INavigationElement = {
    title: "Accounts",
    headerTitle: "Accounts",
    path: 'Accounts/',
    to: '/Accounts',
    navigate: (navigateFnc: Function) => { navigateFnc(`/Accounts`) }
}

export const Inventory: INavigationElement = {
    title: "Inventory",
    headerTitle: "Inventory",
    path: 'Inventory/:entityName?',
    to: '/Inventory',
    navigate: (navigateFnc: Function, entityName: string) => { navigateFnc(`/Inventory/${entityName}`) }
}

export const OperatorSettings: INavigationElement = {
    title: "Settings",
    headerTitle: "Settings",
    path: 'OperatorSettings/',
    to: '/OperatorSettings',
    navigate: (navigateFnc: Function) => { navigateFnc(`/OperatorSettings`) }
}

export const MyAccount: INavigationElement = {
    title: "My Account",
    headerTitle: "My Account",
    path: 'MyAccount/',
    to: '/MyAccount',
    navigate: (navigateFnc: Function) => { navigateFnc(`/MyAccount`) }
}

export const Documentation: INavigationElement = {
    title: "Documentation",
    headerTitle: "Documentation",
    path: 'Documentation/',
    to: '/Documentation',
    navigate: (navigateFnc: Function) => { navigateFnc(`/Documentation`) }
}

export const Workstations: INavigationElement = {
    title: "Workstations",
    headerTitle: "Workstations",
    path: 'Workstations/',
    to: '/Workstations',
    navigate: (navigateFnc: Function) => { navigateFnc(`/Workstations`) }
}

export const view: INavigationElement = {
    title: "View",
    headerTitle: "View",
    path: 'view/:entityName/:entityId',
    to: '/view',
    navigate: (navigateFnc: Function, entityName: string, entityId: string, state: any, tab?: number) => { navigateFnc(`/view/${entityName}/${entityId}#${tab ?? 0}`, { state }) }
};

export const create: INavigationElement = {
    title: "Create",
    headerTitle: "Create",
    path: 'create/:entityName/',
    to: '/create',
    navigate: (navigateFnc: Function, entityName: string, state: any) => { navigateFnc(`/create/${entityName}`, { state }) }
};

export const edit: INavigationElement = {
    title: "Edit",
    headerTitle: "Edit",
    path: 'edit/:entityName/:entityId',
    to: '/edit',
    navigate: (navigateFnc: Function, entityName: string, entityId: string) => { navigateFnc(`/edit/${entityName}/${entityId}`) }
}

export const editWithParent: INavigationElement = {
    title: "Edit",
    headerTitle: "Edit",
    path: 'edit/:entityName/:entityId/:parentEntityName/:parentEntityId',
    to: '/edit',
    navigate: (navigateFnc: Function, entityName: string, entityId: string, parentEntityName: string, parentEntityId: string) => { navigateFnc(`/edit/${entityName}/${entityId}/${parentEntityName}/${parentEntityId}`) }
}

export const ensureCreated: INavigationElement = {
    title: '',
    headerTitle: '',
    path: 'ensure-created',
    to: '/ensure-created',
    navigate: (navigateFnc: Function) => { navigateFnc('/ensure-created') }
};

export const DisposalsPicking: INavigationElement = {
    title: "DisposalsPicking",
    headerTitle: "Picking",
    path: 'DisposalsPicking/:disposalId',
    to: '/DisposalsPicking',
    navigate: (navigateFnc: Function, disposalId: string) => { navigateFnc(`/DisposalsPicking/${disposalId}`) }
}

export const RecallsPicking: INavigationElement = {
    title: "RecallsPicking",
    headerTitle: "Picking",
    path: 'RecallsPicking/:recallId',
    to: '/RecallsPicking',
    navigate: (navigateFnc: Function, recallId: string) => { navigateFnc(`/RecallsPicking/${recallId}`) }
}

export const RecallsPacking: INavigationElement = {
    title: "RecallsPacking",
    headerTitle: "Packing",
    path: 'RecallsPacking/:recallId',
    to: '/RecallsPacking',
    navigate: (navigateFnc: Function, recallId: string) => { navigateFnc(`/RecallsPacking/${recallId}`) }
}

export const CreateUplifts: INavigationElement = {
    title: "CreateUplift",
    headerTitle: "Uplifts",
    path: 'CreateUplift/:upliftId?',
    to: '/CreateUplift',
    navigate: (navigateFnc: Function, upliftId?: string) => { navigateFnc(`/CreateUplift${upliftId ? `/${upliftId}` : ""}`) }
};

export const CreateReturns: INavigationElement = {
    title: "CreateReturn",
    headerTitle: "Uplifts",
    path: 'CreateReturn/:returnId?',
    to: '/CreateReturn',
    navigate: (navigateFnc: Function, returnId?: string) => { navigateFnc(`/CreateReturn${returnId ? `/${returnId}` : ""}`) }
};

export const Requests: INavigationElement = {
    title: "Requests",
    headerTitle: "Requests",
    path: 'Requests/:entityName?',
    to: '/Requests',
    navigate: (navigateFnc: Function, entityName: string) => { navigateFnc(`/Requests/${entityName}`) }
}

export const Users: INavigationElement = {
    title: "Users",
    headerTitle: "Users",
    path: 'users',
    to: '/users',
    navigate: (navigateFnc: Function) => { navigateFnc('/users') }
};

/**
 * Returns the first accessible navigation item based on user permissions.
 * The order matches the navigation menu order in NavMenu.tsx:
 * 1. Inventory
 * 2. Establishments
 * 3. Requests
 * 4. Documentation
 * 5. Workstations
 * 6. Operator Settings
 */
export function getFirstAccessibleNavigation(permissions: AccessPermissions | undefined): INavigationElement | null {
    if (!permissions) {
        return null;
    }

    // 1. Check Inventory (Cases_And_Ranges, Specimens, or Inventory_Containers)
    if (hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Cases_And_Ranges) ||
        hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Specimens) ||
        hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Inventory_Containers)) {
        return Inventory;
    }

    // 2. Check Establishments (Customers or Accounts)
    if (hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Customers) ||
        hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Accounts)) {
        return Establishments;
    }

    // 3. Check Requests (Make_Recall_Request, Make_Disposal_Request, Recall_Requests, or Manage_Recalls)
    if (hasPermission(permissions, PermissionTypes.write, PermissionConcerns.Make_Recall_Request) ||
        hasPermission(permissions, PermissionTypes.write, PermissionConcerns.Make_Disposal_Request) ||
        hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Recall_Requests) ||
        hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Manage_Recalls)) {
        return Requests;
    }

    // 4. Check Documentation
    if (hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Documentation)) {
        return Documentation;
    }

    // 5. Check Workstations
    if (hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Workstations)) {
        return Workstations;
    }

    // 6. Check Operator Settings
    if (hasPermission(permissions, PermissionTypes.read, PermissionConcerns.Navigation_Settings_Cellnass)) {
        return OperatorSettings;
    }

    return null;
}
